import React, { useState, useEffect } from 'react';
import StyledBox from 'views/information-module/PotentialMarketsView/PotentialMarketsView.styles';
import { useTranslation } from 'next-i18next';
import {
  FranchiseCommonSections,
  StyledFranchiseTitleWithDesc,
} from 'views/information-module/common/components';
import { Box } from '@mui/material';
import axios, { API } from 'lib/config/axios';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import PATHS from 'lib/navigation/paths';

const PotentialMarketsView = (props) => {
  const { t } = useTranslation('fe_er_potential_markets_page');
  const handleErrorResponse = useErrorsHandler();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };
  const rebrandingImage = {
    src: '/imgs/franchise/MarketOpportunities.jpg',
    alt: t('fe_er_potential_markets_page:header'),
  };
  const verticaltabs = [
    {
      label: t('fe_er_potential_markets_page:er_locations_header'),
      value: 1,
      href: '#PMVLocations',
    },
    {
      label: t('fe_er_potential_markets_page:opportunities_header'),
      value: 2,
      href: '#PMVOpportunities',
    },
  ];

  const activeTab = 6;
  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);

  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>
      <StyledBox>
        <FranchiseCommonSections
          activeTab={activeTab}
          verticaltabs={verticaltabs}
          titleWithImage={rebrandingImage}
          titleWithImgText={t('fe_er_potential_markets_page:header')}>
          <Box mb={2} id="PMVLocations">
            <StyledFranchiseTitleWithDesc
              titleVariant="h3"
              component="h2"
              title={t('fe_er_potential_markets_page:er_locations_header')}
              description={t('fe_er_potential_markets_page:er_locations_text', {
                inquiry_link: PATHS.franchise.becomeFranchiseDoc(),
              })}
            />
          </Box>
          <Box
            className="PMOpp"
            id="PMVOpportunities"
            mt={{ lg: 11, md: 8, sm: 6 }}
            mb={5}>
            <StyledFranchiseTitleWithDesc
              titleVariant="h3"
              component="h2"
              title={t('fe_er_potential_markets_page:opportunities_header')}
              description={t(
                'fe_er_potential_markets_page:opportunities_text',
                {
                  inquiry_link: PATHS.franchise.becomeFranchiseDoc(),
                },
              )}
            />
          </Box>
        </FranchiseCommonSections>
      </StyledBox>
    </>
  );
};

export { PotentialMarketsView };
